<template lang="html">
<section class="aChat">
    <div v-if="popped">
        <br>
        <div v-if="true" class="Vlt-grid">
            <div class="Vlt-col Vlt-col--A-2of2" style="padding-left: 50px;">
                <div class="left"><span style="color:white; background-color: green"><b>{{' '+users[0].user}} ({{users[0].lang}})</b></span></div>
                <div class="center"><span style="color:blue; background-color: AntiqueWhite"><b> {{'Translations'}} </b></span></div>
                <div class="right"><b><span style="color:white; background-color: BlueViolet">{{users[1].user}} ({{users[1].lang}})</span></b></div>
                <br />
                <basic-vue-chat :useInput="Boolean(false)" class="Vlt-margin--top0 Vlt-margin--bottom1" :title="''" :new-message="message" :initial-feed="myChats" />
            </div>
        </div>
    </div>
    <div v-if="bad">
        <h1>Sorry, not a valid ID for a current conversation.</h1>
    </div>
</section>
</template>

<script lang="js">
import {
    VltIcon,
    VltButton,
    VltCard,
    VltTab,
    VltGrid,
    VltCol,
    VltField,
    VltInput,
    VltCallout,
} from "@vonagevolta/vue";
import {
    FontAwesomeIcon
} from '@fortawesome/vue-fontawesome';
import {
    $HTTPDEMO,
    requestHandler
} from '@/services/nidsService.js';
import Pusher from "pusher-js";
import BasicVueChat from "@/components/chatter/src/components/basic-vue-chat/BasicVueChat";
import axios from 'axios';
export default {
    name: 'aChat',
    props: {
        chats: {
            type: Array,
            required: false
        },
        newChats: {
            type: Array,
            required: false
        }
    },
    components: {
        "vlt-icon": VltIcon,
        "vlt-button": VltButton,
        "vlt-field": VltField,
        "vlt-input": VltInput,
        "vlt-callout": VltCallout,
        "basic-vue-chat": BasicVueChat,
        //        "font-awesome-icon": FontAwesomeIcon,
    },
    data() {
        return {
            clid: null,
            uuid: null,
            clr: 0,
            bad: false,
            message: {},
            postscript: "translation",
            selected: '0',
            pusher: {},
            myChats: [],
            chunks: [],
            popped: false,
            NODEDEMO: null,
            messageList: [],
            newMessagesCount: 0,
            isChatOpen: true,
            pchannel: "rt_interpreting",
            pevent: "transcript",
            users: [{
                    id: 0,
                    user: "User_1",
                    lang: "en-US",
                    voice: -1,
                    curLang: null,
                    phone: "",
                    pretty: "",
                    greeting: "shortGreeting",
                },
                {
                    id: 1,
                    user: "User_2",
                    lang: "es-MX",
                    voice: -1,
                    curLang: null,
                    phone: "",
                    pretty: "",
                    greeting: "shortGreeting",
                }
            ],
        }
    },
    watch: {
        newChats: function (newVal) {
            console.log("Watched updated newChats")
            this.newChats.forEach((item, index) => {
                let obj = this.addMessage(item.src_entity, item.dst_entity, item.channel, item.text);
            });
        }
    },
    methods: {
        processData(data) {
            if (data.confName != this.uuid) { // Not ours!  Ignore.
                console.log("Not ours, ignore");
                return;
            }
            let id = parseInt(data.userId);
            id = 1 - id;
            let date = new Date().toLocaleTimeString([], {
                hourCycle: 'h24'
            });
            let txt = "";
            let bubble = "AntiqueWhite"; //"AliceBlue";
            let color = 'margin-left: 30px;color:black; background-color: ' + bubble + '; font-weight: bold';
            if ("transcript" in data) {
                txt = data.transcript;
                if (id > 0) {
                    color = 'color:white; background-color: green; font-weight: bold';
                } else {
                    color = 'color:white; background-color: BlueViolet; font-weight: bold';
                }
            } else if ("translation" in data) {
                id = 1 - id; // Switch sides for the diplay...
                txt = data.translation;
                if (data.type && data.type == "system") {
                    color = 'margin-left: 40px;color:red; background-color: ' + bubble + '; font-weight: bold';
                } else {
                    if (id == 0) {
                        color = 'margin-right: 140px;color:green; background-color: ' + bubble + '; font-weight: bold';
                    } else {
                        color = 'margin-left: 140px;color:BlueViolet; background-color: ' + bubble + '; font-weight: bold';
                    }
                }
                //txt = "(" + data.
            } else {
                console.log("Invalid, neither trascription nor translation.");
                return;
            }
            if ((data.userId == -1) || txt.includes('Vonage Programmable Communications') || txt.includes('Ahora puedes hablar')) {
                txt = '(From System, in ' + data.sourceLanguageCode + ') ' + txt;
                color = 'margin-left: 40px;color:blue; background-color: ' + bubble + '; font-weight: bold';
            } else {

            }
            this.message = {
                id: id,
                author: '',
                contents: txt,
                date: date,
                msgstyle: color
            };
            console.log("Message: ", this.message);
            return {
                id: id,
                author: '',
                contents: txt,
                date: date,
                msgstyle: color
            }
        },

        onNewOwnMessage(msg) {
            console.log("Sending type : " + this.selected + " with message: " + msg);
            var chan = "sms";
            if (this.selected == 2) {
                chan = "voice";
            } else if (this.selected == 1) {
                chan = "whatsapp";
            } else if (this.selected == 3) {
                chan = "mms";
            }
            this.NODEDEMO.post('/chatsend', {
                channel: chan,
                text: msg
            });
        },
    },
    created() {
        if (this.$route.params.clid) {
            this.clid = this.$route.params.clid
        } else if (this.$route.query.clid) {
            this.clid = this.$route.query.clid
        } else {
            console.log("Sorry, no CLID entered!");
            this.bad = true;
            return;
        }
        console.log("In CCTranslate Chat component: " + this.clid);
        this.NODEDEMO = axios.create({
            baseURL: "https://vids.vonage.com/" + this.postscript,
            headers: {
                'Content-Type': 'application/json'
            }
        })
        this.NODEDEMO.post('/register', {
            phone: this.clid,
        }).then(response => {
                console.log("Results of register: ", response);
                let data = response.data;
                if (data.confName) {
                    this.uuid = data.confName
                }
                if (data.messages) {
                    data.messages.forEach((item, index) => {
                        this.$nextTick(() => {
                            let obj = this.processData(item);
                            this.myChats.push(obj);
                        })
                    });
                }
                let us = Object.values(data);
                us.forEach((item, index) => {
                    if ((typeof item === 'object') && ("userId" in item)) { // This is a user record
                        console.log("Got id of user: ", item.userId)
                        this.users[item.userId].lang = item.languageCode;
                        this.users[item.userId].user =  item.userName;
                    }
                });
                this.popped = true;

            let pusher = new Pusher("653f80a13e29cebd21b6", { //Pusher Key
                cluster: 'us3',
                forceTLS: true
            }); 
            this.pusher = pusher; this.channel = pusher.subscribe(this.pchannel); this.channel.bind(this.pevent, data => {
                console.log("Got some translation data: " + JSON.stringify(data));
                if ((!data.confName) || (data.confName != this.uuid)) { // Not ours!  Ignore.
                    return;
                }
                if (!this.chunks[data.chunkUuid]) {
                    this.chunks[data.chunkUuid] = {};
                    if ("transcript" in data) {
                        this.chunks[data.chunkUuid].transcript = data;
                        this.processData(data); // Didn't already exist, so go ahead and process it
                    } else {
                        this.chunks[data.chunkUuid].translation = data;
                    }
                } else { // it DOES already exist...
                    if ("transcript" in data) { // Ok, it already exists, but HERE is the transcript, meaning we already got a translation
                        console.log("************Adjusting Timing for Chunks!")
                        this.chunks[data.chunkUuid].transcript = data;
                        this.processData(data); // Send the transcription...
                        //Then send the translation...
                        this.$nextTick(() => {
                            this.processData(this.chunks[data.chunkUuid].translation); // Send the transcription...
                        })
                    } else {
                        this.chunks[data.chunkUuid].translation = data;
                        this.processData(data); // Send the transcription...
                    }
                }
            });
        })
},
beforeDestroy() {
    console.log("beforeDestroy for chat")
    if (this.pusher) {
        this.pusher.unsubscribe("lex");
    }
},
}
</script>

<style lang="scss" scoped>
.left {
  float: left;
}

.center {
  float: left;
  padding-left: 120px;
}

.right {
  float: left;
  padding-left: 110px;
}

.sel {
  padding: 5px;
  font-weight: bold;
}

//@import "@basic-vue-chat/assets/scss/modules/_all.scss";

$primary: red;
$secondary: blue;
$header-color: blue;
$window-height: 200px;
// above the following import you can override default values of variables like $primary
</style>
